import { api } from './client';
import type { BingDateGrain } from './bingDashboard';
import type { AppLikeOverviewParams, AppLikeOverviewResponse } from './applovinDashboard';

export type GoogleReportType = 'overview' | 'target' | 'new_old' | 'detail' | 'independent';

export interface GoogleReportRow {
  dimensions: Record<string, string>;
  metrics: Record<string, number>;
}

export interface GoogleReportResponse {
  list: GoogleReportRow[];
  summary: GoogleReportRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: GoogleReportType;
}

export interface GoogleOptionResponse {
  list: string[];
}

export interface GoogleOptionParams {
  brand_id: string;
  site_id: string;
  field: string;
}

export interface GoogleReportParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: GoogleReportType;
  dimensions?: string;
  target_type?: string;
  new_old_type?: string;
  ad_form_type?: string;
  material_type?: string;
  price_type?: string;
  product_type?: string;
  product_posi?: string;
  new_customer_segment?: string;
  new_customer_segment_detail?: string;
  old_customer_segment?: string;
  old_customer_segment_detail?: string;
  campaign_id?: string;
  campaign_name?: string;
  adset_name?: string;
  ad_name?: string;
  ad_text_filters?: string;
  account_name?: string;
}

export interface VooglamGoogleOverviewParams extends AppLikeOverviewParams {
  dimensions?: string;
  country?: string;
  traffic_type?: string;
  campaign_type?: string;
  customer_segmentation?: string;
}

type ApiEnvelope<T> = { code: number; data: T; message?: string };

export const googleDashboardApi = {
  getOptions: (params: GoogleOptionParams) =>
    api.get<ApiEnvelope<GoogleOptionResponse>>('/ad-dashboard/google/options', { params }),
  getReport: (params: GoogleReportParams) =>
    api.get<ApiEnvelope<GoogleReportResponse>>('/ad-dashboard/google/report', { params }),
  getVooglamOverview: (params: VooglamGoogleOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/google/v/overview', { params }),
  getVooglamTrend: (params: VooglamGoogleOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/google/v/trend', { params }),
};
